
import Vue from 'vue';
type TabItem = {
  label: string;
  id: string;
};
/**
 * > *This component is deprecated, please go to V2 > Tabs*
 *
 * Tabs
 *
 * Navigation with tab.
 */
export default Vue.extend<any, any, any, any>({
  props: {
    /**
     * Tab list options.<br />
     * Model:
     *
     * - id: `required` ID of tab
     * - label: `required` Title of the tab
     * - description: `optional` Description of the tab
     */
    items: {
      type: Array,
      default: () => [] as TabItem[]
    },
    /**
     * Current active tab ID.
     */
    value: {
      type: [String, Number],
      default: null
    },
    /**
     * Default tab is current active tab is empty.
     */
    defaultTab: {
      type: Number,
      default: null
    },
    /**
     * Tab is circular style.
     */
    circular: {
      type: Boolean,
      default: false
    },
    /**
     * Active tab text color.
     */
    color: {
      type: String,
      default: '#ff6a00'
    },
    /**
     * Border radius of the Tab
     */
    radius: {
      type: String,
      default: '30px'
    },
    /**
     * Tab is full width.
     */
    full: {
      type: Boolean,
      default: true
    },
    /**
     * Active tab background color.
     */
    activeTabColor: {
      type: String,
      default: ''
    },
    /**
     * Inactive tab background color.
     */
    inactiveTabColor: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      activeIndex: 0
    };
  },
  mounted() {
    try {
      this.activeIndex = this.defaultTab
        ? this.defaultTab
        : (this.items as TabItem[]).map(item => item.id).indexOf(this.value.toString());
    } catch (error) {
      console.log(error);
    }
  },
  computed: {
    computedType() {
      return {
        'tab-bar-container': !this.circular,
        'tab-bar-container-circular': this.circular
      };
    },
    computedIndicator() {
      return {
        'tab-bar-indicator': !this.circular,
        'tab-bar-indicator-circular': this.circular
      };
    },
    tabStyle() {
      return {
        gridTemplateColumns: `repeat(${this.items.length}, calc(100% / ${this.items.length}))`,
        borderRadius: this.radius
      };
    },
    indicatorStyle() {
      return {
        left: this.full ? `${(100 / this.items.length) * this.activeIndex}%` : this.getCircularIndicator(),
        width: `${100 / this.items.length}%`,
        backgroundColor: this.color,
        height: this.circular ? (this.full ? '100%' : `85%`) : null,
        borderRadius: this.radius
      };
    }
  },
  methods: {
    computedItem(index: any) {
      return {
        'tab-item': !this.circular,
        'tab-item-circular': this.circular,
        active: this.activeIndex === index
      };
    },
    computedStyle(index: any) {
      if (Boolean(this.activeTabColor) || Boolean(this.inactiveTabColor)) {
        return {
          backgroundColor: this.activeIndex == index ? this.activeTabColor : this.inactiveTabColor,
          transition: `background-color 0.5s`
        };
      }
      return;
    },

    label(index: any) {
      return {
        color: this.computedColor(index),
        zIndex: 1
      };
    },
    getCircularIndicator() {
      var middle = this.items[Math.floor((this.items.length - 1) / 2)];
      if (this.circular) {
        if (this.activeIndex + 1 == this.items.length) {
          return `${(100 / this.items.length) * this.activeIndex - 1}%`;
        } else if (this.activeIndex != 0 && this.activeIndex + 1 != this.items.length) {
          return `${(100 / this.items.length) * this.activeIndex}%`;
        } else {
          return `${(100 / this.items.length) * this.activeIndex + 1}%`;
        }
      } else {
        return `${(100 / this.items.length) * this.activeIndex}%`;
      }
    },
    computedColor(index: any) {
      let active = this.activeIndex === index;
      let colors = '#fff';
      if (!this.circular) {
        if (active) {
          colors = this.color;
        } else {
          colors = '#b5b7b9';
        }
      } else {
        if (!active) {
          colors = '#4c75a7';
        } else {
          colors = '#fff';
        }
      }

      return colors;
    },
    handleClickTab(id: string, index: number) {
      this.activeIndex = index;
      /**
       * Handle when user click the tab
       * @event input
       * @type {function}
       */
      this.$emit('input', index);
      /**
       * Handle when user click the tab
       * @event change
       * @type {function}
       */
      this.$emit('change', id);
    }
  }
});
